import { clientSlug } from '../utils/clientLogo';

function partner(name, domain) {
  return { name, slug: clientSlug(name), domain };
}

/** Authorised distributors & partners — Home trusted section, About page */
export const AUTHORIZED_PARTNERS = [
  partner('ELANTAS Beck India Ltd.', 'elantas.com'),
  partner('Tremco CPG (India)', 'tremcocpg.com'),
  partner('Sika India Pvt. Ltd.', 'sika.com'),
  partner('Asian Paints', 'asianpaints.com'),
  partner('BASF India Ltd.', 'basf.com'),
  partner('Pidilite Industries', 'pidilite.com'),
  partner('Fosroc India Pvt Ltd.', 'fosroc.com'),
];
